import React,{useState, useEffect}  from 'react';
 
import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cswhile(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
  
return(
    <div>
      <Sides/>
     
      <Helmet>
 
 <title>Learn Free JavaScript While Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript While tutorial for beginners.While in Javascript is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Javascript While,Javascript While for loop,While foreach Javascript,Javascript foreach While,javascript while loop,javascript while loop break,javascript while true,javascript while statement" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-while" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Javascript while loop</h1>
    <div className="first">
        <a href="/javascript-looping-statement">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-do-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        

    <p className="mt-4 para">While loop will give this condition and the body of the loop Executes until the given condition is false</p>
    


<h2 className="headings">while loop Javascript syntax:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
  <span className="qwerty-10">while</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">condition</span> 
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&#123; </span>

  {"\n"}
  <span className="qwerty-2">&nbsp;statement</span>
      {"\n"}
  <span className="qwerty-3">&#125; </span>

{"\n"}{"\n"}
     </code>
      </pre>        
    </div>
    

<h2 className="mt-4 mh2"> Javascript While loop Examples:</h2>



<h2 className="headings">Q-Write a program Addition or increment while loop Example in Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}
<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty">=</span>
            <span className="qwerty-1">1; </span>
          {"\n"}




          {"\n"}
          <span className="qwerty-10">&nbsp;&nbsp;while</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty">&#60;=</span>  
      <span className="qwerty-1">10</span>   
      <span className="qwerty-1">)</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
      {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
          <span className="qwerty">++</span>
          <span className="qwerty-1">;</span>
      {"\n"}  {"\n"}
      <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OR</span>
      {"\n"}  {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
          <span className="qwerty">=</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty">+</span>
          <span className="qwerty-1">1;</span>
          {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
     
      <span className="qwerty-1">);</span>
      {"\n"}
         
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
    
     
    
    
     
     
    
    
    
    {"\n"}







<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
      
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
        
          <span className="qwerty-3">&nbsp;2 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;3 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;4 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;5 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;6 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;7 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;8 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;9 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;10 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;11 </span>                    
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Q-Write a program Subtract or Decrement in while loop Example in Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}
<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty">=</span>
            <span className="qwerty-1">10; </span>
          {"\n"}




          {"\n"}
          <span className="qwerty-10">&nbsp;&nbsp;while</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty">&#62;=</span>  
      <span className="qwerty-1">1</span>   
      <span className="qwerty-1">)</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
      {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
          <span className="qwerty">--</span>
          <span className="qwerty-1">;</span>
      {"\n"}  {"\n"}
      <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OR</span>
      {"\n"}  {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
          <span className="qwerty">=</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty">-</span>
          <span className="qwerty-1">1;</span>
          {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
   
      <span className="qwerty-1">);</span>
      {"\n"}
         
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
    
     
    {"\n"}

<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
      
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
   
          <span className="qwerty-3">&nbsp;9 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;8 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;7 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;6 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;5 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;4 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;3 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;2 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;1 </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;0 </span>                    
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>

<h2 className="mt-4 mh2">While loop uses logic operator in Javascript:</h2>



        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            {"\n"}
      <span className="qwerty-10">while</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty">&#60;=</span>  
      <span className="qwerty-1">10</span> 
      <span className="qwerty"> && </span> 
      <span className="qwerty-4">a</span>
      <span className="qwerty">&#62;=</span>  
      <span className="qwerty-1">1</span> 
      <span className="qwerty-1">)</span>
      {"\n"}
      <span className="qwerty-10">while</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty">&#60;=</span>  
      <span className="qwerty-1">10</span> 
      <span className="qwerty"> || </span> 
      <span className="qwerty-4">a</span>
      <span className="qwerty">&#62;=</span>  
      <span className="qwerty-1">1</span> 
      <span className="qwerty-1">)</span>
      {"\n"}
    
    {"\n"}
         
            </code>
          </pre>        
        </div>
        


<h2 className="mt-4 mh2">While Loop Reverse Javascript:</h2>



<h2 className="headings">Q-Write a program to input an integer number and print in reverse in Javascript Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}
<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty">=</span>
            <span className="qwerty-1">2560; </span>
          {"\n"}




          {"\n"}
          <span className="qwerty-10">&nbsp;&nbsp;while</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty">&#62;</span>  
      <span className="qwerty-1">0</span>   
      <span className="qwerty-1">)</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
         
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
          <span className="qwerty">=</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty">%</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty">/</span>
          <span className="qwerty-1">10;</span>
          {"\n"}
 
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
    
     
    
    
     
     
    
    
    
    {"\n"}







<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
      
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;2560 </span>                    
          {"\n"}
          
            </code>{"   "}
            </pre>
      </div>
    </div>
    




<h2 className="headings">Q-Write a program to input found out the sum of digits of integer no in Javascript Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}
<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty">=</span>
            <span className="qwerty-1">2560; </span>
            <span className="qwerty-3">sum</span>
            <span className="qwerty">=</span>
            <span className="qwerty-1">0; </span>
          {"\n"}




          {"\n"}
          <span className="qwerty-10">&nbsp;&nbsp;while</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty">&#62;</span>  
      <span className="qwerty-1">0</span>   
      <span className="qwerty-1">)</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
      {"\n"}
      
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sum</span>
          <span className="qwerty">=</span>
          <span className="qwerty-4">sum</span>
          <span className="qwerty">+</span>
          <span className="qwerty-1">10;</span>
          {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
          <span className="qwerty">=</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty">/</span>
          <span className="qwerty-1">10;</span>
          {"\n"}
 
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}
 
      <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span>
      <span className="qwerty-3">Sum Of Digits=</span>
      <span className="qwerty-1">"</span>
      <span className="qwerty">+</span>
      <span className="qwerty-4">sum</span>
      <span className="qwerty-1">);</span>
      {"\n"}
    
    {"\n"}


<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
      
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;Sum of Digits= </span>  
          <span className="qwerty-10">3270 </span>                  
          {"\n"}
          
            </code>{"   "}
            </pre>
      </div>
    </div>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/javascript-looping-statement">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-do-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>

    </div>
)

}
export default Cswhile;